import React from "react";
import Grommet from "./Grommet";
import { RadioButton as GRadioButton } from "grommet";
const RadioButtonWMO = props =>
  props.custom ? (
    <Grommet
      theme={{
        radioButton: {
          size: "20px",
          border: {
            color: "dark-2"
          },
          check: { extend: { border: "2px solid #333" } },
          icon: { extend: { fill: "#333" } },
          extend: {
            alignSelf: "flex-start"
          }
        }
      }}
    >
      <GRadioButton {...props}>{props.children}</GRadioButton>
    </Grommet>
  ) : (
    <GRadioButton {...props}>{props.children}</GRadioButton>
  );
export default RadioButtonWMO;
